module.exports = __webpack_public_path__ + "static/media/sh-ta.ef089c7a.svg";